/**
 * Rozdělí popis produktu na rozklikávací záložky (accordion) podle existující
 * psací konvence: odstavec, který ZAČÍNÁ tučným textem a ten tučný text je
 * hned následovaný <br>, se stane záložkou (nadpis = tučný text, obsah =
 * zbytek odstavce za tím <br>). Ostatní odstavce (běžné vyprávěcí věty)
 * zůstávají beze změny jako obyčejný text.
 *
 * Nemění žádný existující text - jen ho přeskládá do jiné vizuální podoby.
 */
(function () {
  var SHORT_LEAD_MAX_LENGTH = 4;

  function splitParagraph(p) {
    var nodes = Array.prototype.slice.call(p.childNodes);
    var segments = [{ heading: null, nodes: [] }];
    var current = segments[0];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'STRONG') {
        var next = nodes[i + 1];
        if (next && next.nodeType === Node.ELEMENT_NODE && next.tagName === 'BR') {
          var leadingText = current.nodes
            .map(function (n) {
              return n.textContent || '';
            })
            .join('')
            .trim();

          // Krátký "leading" text (typicky jen emoji) patří do jeho VLASTNÍHO
          // nadpisu jen tehdy, když ještě nejsme uvnitř žádné jiné záložky -
          // jinak by se sem omylem vtáhl celý obsah předchozí záložky (viz
          // "Formáty" + "Tisk" ve stejném odstavci).
          var foldLeadingIntoHeading = current.heading === null && leadingText.length <= SHORT_LEAD_MAX_LENGTH;

          var heading = foldLeadingIntoHeading
            ? (leadingText + ' ' + (node.textContent || '').trim()).trim()
            : (node.textContent || '').trim();

          if (foldLeadingIntoHeading) {
            segments.pop();
          }

          var tabSegment = { heading: heading, nodes: [] };
          segments.push(tabSegment);
          current = tabSegment;

          i += 1; // přeskočit hned následující <br>, je to jen oddělovač
          continue;
        }
      }

      current.nodes.push(node);
    }

    return segments;
  }

  function buildAccordionItem(heading, bodyNodes, caretTemplate) {
    var wrapper = document.createElement('div');
    wrapper.className = 'product__accordion accordion quick-add-hidden';

    var details = document.createElement('details');
    var summary = document.createElement('summary');
    var titleWrap = document.createElement('div');
    titleWrap.className = 'summary__title';

    var h2 = document.createElement('h2');
    h2.className = 'h4 accordion__title inline-richtext';
    h2.textContent = heading;
    titleWrap.appendChild(h2);
    summary.appendChild(titleWrap);

    if (caretTemplate) {
      summary.appendChild(caretTemplate.content.cloneNode(true));
    }

    var content = document.createElement('div');
    content.className = 'accordion__content rte';
    bodyNodes.forEach(function (node) {
      content.appendChild(node);
    });

    details.appendChild(summary);
    details.appendChild(content);
    wrapper.appendChild(details);

    return wrapper;
  }

  function init(container) {
    if (!container || container.dataset.accordionEnhanced === 'true') return;
    container.dataset.accordionEnhanced = 'true';

    var caretTemplate = document.getElementById('description-accordion-caret-template');
    var paragraphs = Array.prototype.slice.call(container.querySelectorAll(':scope > p'));
    var tabs = [];

    paragraphs.forEach(function (p) {
      var segments = splitParagraph(p);
      var tabSegments = segments.filter(function (s) {
        return s.heading !== null;
      });

      if (tabSegments.length === 0) return; // čistě úvodní odstavec, nechat beze změny

      var leftoverIntro = segments.filter(function (s) {
        return s.heading === null;
      });
      var hasLeftoverContent = leftoverIntro.some(function (s) {
        return s.nodes.some(function (n) {
          return (n.textContent || '').trim() !== '';
        });
      });

      if (hasLeftoverContent) {
        var replacement = document.createElement('p');
        leftoverIntro.forEach(function (s) {
          s.nodes.forEach(function (n) {
            replacement.appendChild(n);
          });
        });
        p.replaceWith(replacement);
      } else {
        p.remove();
      }

      tabSegments.forEach(function (s) {
        tabs.push(s);
      });
    });

    var wrapper = document.createElement('div');
    wrapper.className = 'product-description-accordion-wrapper';

    tabs.forEach(function (tab) {
      wrapper.appendChild(buildAccordionItem(tab.heading, tab.nodes, caretTemplate));
    });

    container.insertAdjacentElement('afterend', wrapper);
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-product-description-accordion]');
    containers.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
